import { styled, Grid, Typography, Dialog, TableRow, TableHead } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  gap: "20px",
  height: "73vh",
  overflow: "auto",
});

export const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    maxWidth: "96vw",
  },
});

export const DocumentViewerContainer = styled(Grid)(({ theme }) => ({
  width: "50%",
  border: `1px solid ${theme.palette.secondary.light}`,
  borderRadius: "5px",
  maxHeight: "73vh",
  overflow: "auto",
  "& #main-viewer": {
    height: "65vh",
    scale: "0.8",
  },
}));

export const PlaceholdersContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
});

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  "& .MuiTableCell-root": {
    backgroundColor: theme.palette.background.paper,
  },
}));

export const StyledTableRow = styled(TableRow)({
  "& .MuiAutocomplete-root": {
    width: "400px",
  },
  "& .MuiButton-root": {
    opacity: "0.2",
    gap: "3px",
    width: "220px",
    textTransform: "none",
    "&:hover": {
      opacity: "1",
    },
  },
  "& .MuiIconButton-root": {
    fontSize: "24px",
  },
});

export const PleaceholderTag = styled(Typography)({
  width: "200px",
});
